export default __webpack_public_path__ + "static/media/coupons-inactive.2de31e20.svg";